<template>
    <div class="container">
        <h1 class="text-xl font-bold">Pagina di debug e utility</h1>
    </div>

    <div class="grid grid-cols-2 gap-2">
        <div>
            <NextButton component="a" href="/ricalcola_bi" class="p-1 inline-block">Ricalcola Bi</NextButton>
        </div>
        <p>Funzione per ricalcolare tutti i record della BI</p>

        <div>
            <NextButton component="a" href="/auth/google/redirect" class="p-1 inline-block">Login Google</NextButton>
        </div>
        <p>Funzione con Google</p>

        <div>
            <NextButton component="a" href="/auth/microsoft/redirect" class="p-1 inline-block">Login Ms</NextButton>
        </div>
        <p>Login con Microsoft</p>

        <div>
            <NextButton component="a" href="/csv_contatti" class="p-1 inline-block">Sincornizza SB</NextButton>
        </div>

        <p>Sincornizza tutti i contatti su SendinBlue</p>

        <div>
            <NextButton @click="test" class="p-1 inline-block">test</NextButton>
        </div>
    </div>

<!--    <div class="mousemove w-full bg-red relative" style="height: 500px">-->

<!--        <span draggable="true" class="drag w-32 h-32 bg-black absolute"  :style="{left:`${left}px`,top:`${top}px`}"></span>-->
<!--    </div>-->

    <MapViewer
        v-model:placeId="placeId"
        v-model:lat="lat"
        v-model:lng="lng"
        @addressInformationChange="onAddressInformationChange"
    ></MapViewer>


</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Loading from "@/components/Loading.vue";
import fornitoriManager from "../api/FornitoriManager";
import NextButton from "@/components/NextButton.vue";
import MapViewer from "@/components/Address/MapViewer.vue";

@Options({
    name:'Debug',
    components: {MapViewer, NextButton, Loading},
})
export default class Debug extends Vue {

    logout() {
        this.axios.get('/sanctum/csrf-cookie').then(response => {
            this.axios.post('http://localhost/api/logout').then((e) => {
                console.log(e)
            }).catch((e) => {
                console.log(e)
            })
        });
    }

    left = 0
    top = 0

    placeId = 'ChIJB5hwGxqF1RIRjeyKcTa4wrs'
    lat: number = 41.9099533
    lng: number = 12.3711917

    start:any = null
    is_dragging = false
    drag_start_pos_x = this.left
    drag_start_pos_y = this.top

    msalInstance: any = null;

    msalConfig = {
        auth: {
            clientId: '8ad45fb8-fdae-4f14-8544-200c4c88ae8f',
            authority: 'https://login.microsoftonline.com/3976c389-ce8e-4748-b2bf-3b45f68ab9f4',
            redirectUri: "http://localhost:8080",
        }
    };

    test(){
        this.axios.get('http://localhost/api/test').then((e) => {
            console.log(e)
        }).catch((e) => {
            console.log(e)
        })
    }

    created() {
        fornitoriManager.fornitoriAutocomplete({search:'next'})
        this.axios.get('http://localhost/api/me').then((e) => {
            console.log(e)
        }).catch((e) => {
            console.log(e)
        })

        // this.axios.get('https://www.googleapis.com/auth/userinfo.email')

    }

    onAddressInformationChange(address: any) {
        console.log(address)
    }

    mounted(){
        const container = document.querySelector('.mousemove')

        container && container.addEventListener('mousemove',(e)=>{
            if(this.is_dragging){
                console.log('m_move')
                //@ts-ignore
                this.left = e.clientX - this.start.clientX +  this.drag_start_pos_x
                //@ts-ignore
                this.top = e.clientY - this.start.clientY+  this.drag_start_pos_y
            }
        })
        const drag = document.querySelector('.drag')
        drag && drag.addEventListener('dragstart', (e)=>{
            // var img = new Image();
            // img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
            // //@ts-ignore
            // e.dataTransfer.setDragImage(img, 0, 0);
            // //@ts-ignore
            // e.dataTransfer.setData('application/node type', this);
            this.start = e
            this.is_dragging = true
            this.drag_start_pos_x = this.left
            this.drag_start_pos_y = this.top
            console.log(e)
        , false})
        drag && drag.addEventListener("drag", (e) => {
            if(this.is_dragging){
                console.log('m_drag')
                //@ts-ignore
                this.left = e.clientX - this.start.clientX +  this.drag_start_pos_x
                //@ts-ignore
                this.top = e.clientY - this.start.clientY+  this.drag_start_pos_y
                console.log('drag',this.left,this.top)
            }
        });
        drag && drag.addEventListener("dragend", (e) => {
            //@ts-ignore
            this.left = e.clientX - this.start.clientX  +  this.drag_start_pos_x
            //@ts-ignore
            this.top = e.clientY - this.start.clientY+  this.drag_start_pos_y
            this.is_dragging = false
            console.log('dragend',e,this.left,this.top)
            // console.log('drag move')
        });
    }
}
</script>


<style lang="scss">
.home {
    background-color: green;
}
</style>
